export default {
  body: {
    padding: 5,
  },
  newData: {
    flex: 1,
    flexDirection: 'row',
  },
  noDataRow: {
    color: 'lightgrey',
    textAlign: 'center',
  },
  noData: {
    fontSize: 150,
    color: 'lightgrey',
  },
  resourceInput: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    padding: 3,
  },
  resourceInputRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  addDetails: {
    margin: 5,
    padding: 5,
  },
  timeCol: {
    width: 60,
  },
  roleCol: {
    width: 90,
  },
  actionCol: {
    width: 125,
  },
  datePicker: {
    display: 'none',
  },
  title: {
    textAlign: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    margin: 5,
  },
  jobInfo: {
    flex: 1,
  },
  description: {
    flex: 2,
  },
  label: {
    fontSize: 11,
    color: 'lightgrey',
  },
  date: {
    flex: 1,
  },
  customer: {
    flex: 1,
  },
  reference: {
    flex: 1,
  },
  paper: {
    padding: 10,
    margin: 5,
  }
};



// WEBPACK FOOTER //
// ./src/components/Jobs/AssignResourcesDialog/styles.js